import { render, staticRenderFns } from "./NFTDetails.vue?vue&type=template&id=3035cc97&scoped=true"
import script from "./NFTDetails.vue?vue&type=script&lang=js"
export * from "./NFTDetails.vue?vue&type=script&lang=js"
import style0 from "./NFTDetails.vue?vue&type=style&index=0&id=3035cc97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035cc97",
  null
  
)

export default component.exports